import React, { Fragment, Component } from 'react';
import popover from '~/js/modules/popovers';

import CheckInPopover from '~/js/components/specials/last-minute-deals/check-in-popover.js';
import ResortCalendars from '~/js/components/specials/last-minute-deals/resort-calendars.js';

export default class ResortsDeals extends Component {
    state = {
      popup: null,
      checkIn: '',
      checkOuts: [],
      calendarLeft: 0,
      left: 0,
      top: 0,
      rstCode: 'SRC'
    }

    componentDidMount() {
      popover();

      window.addEventListener('resize', _globalUtils.debounce(() => this.setState({popup: null}), 200));
      $(document).mouseup((e) => {
        const container = $('.rct-popup');

        if (this.state.popup !== null && container && !container.is(e.target) && container.has(e.target).length === 0) {
          this.setState({popup: null});
        }
      });
    }

    getCalendars() {
      const { lastMinuteDeals, resortsSummary, cdnURL } = this.props;

      return Object.keys(lastMinuteDeals).map(rstCode => {
        return (
          <ResortCalendars
            key={rstCode}
            resortDeals={lastMinuteDeals[rstCode]}
            resortSummary={resortsSummary[rstCode]}
            cdnURL={cdnURL}
            setPopup={this.setPopup}
          />
        );
      });
    }

    setPopup = (
      popup,
      checkIn = this.state.checkIn,
      checkOuts = this.state.checkOuts,
      calendarLeft = this.state.calendarLeft,
      left = this.state.left,
      top = this.state.top,
      rstCode = this.state.rstCode
    ) => {
      const filteredCheckouts = checkOuts.filter((checkOut, index) => checkOuts.indexOf(checkOut) === index);

      this.setState({popup, checkIn, checkOuts: filteredCheckouts, calendarLeft, left, top, rstCode}, () => {
        if(!popup) { return; }
        document.getElementsByClassName('rct-popup')[0].scrollIntoView(
          {behavior: 'smooth', block: 'center', inline: 'center'}
        );
      });
    }

    render() {
      const { popup, checkIn, checkOuts, calendarLeft, left, top, rstCode } = this.state;

      return (
        <Fragment>
          <section className="view-book">
            <div className="container">
              {this.getCalendars()}
            </div>
          </section>
          {popup && <CheckInPopover
            checkIn={checkIn}
            checkOuts={checkOuts}
            calendarLeft={calendarLeft}
            left={left}
            top={top}
            rstCode={rstCode}
            closePopup={() => this.setPopup(null)}
          />}
        </Fragment>
      );
    }
}
